import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ToastService } from 'app/services/toast.service';
import { of } from 'rxjs';
import { catchError, filter, map, mergeMap, switchMap, take, tap, withLatestFrom } from 'rxjs/operators';
import * as fromActions from './actions'
import { Store } from '@ngrx/store';
import * as UserReducer from 'app/state/user/reducer';
import { RevenuecatCustomerService } from 'app/services/dal/revenuecatcustomer.service';



@Injectable()
export class Effects {

  constructor(
    private actions$: Actions,
    private service: RevenuecatCustomerService,
    private store: Store,
  ) { }

  getItem$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(fromActions.loadItem),
        mergeMap((action) => this.service.getItem(action.id)
          .pipe(
            tap((item) => console.log('revenuecat-customer loadItem', item)),
            filter((item) => Boolean(item)),
            map(item => fromActions.loadItemSuccess({ item: item })),
            catchError(error => of(fromActions.loadItemFailure({ error })))
          )
        )
      );
  });


  getItemFromUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.loadItemFromUser),
      withLatestFrom(this.store.select(UserReducer.selectUserId)),
      filter(([action, userId]) => Boolean(userId)),
      mergeMap(([action, userId]) => {
        return this.service.getItem(userId).pipe(
          filter((item) => Boolean(item)),
          map(item => fromActions.loadItemSuccess({ item: item })),
          catchError(error => of(fromActions.loadItemFailure({ error })))
        );
      })
    );
  });



}
